// import request from './huddle-request';
const API_EMAIL_SETTINGS = 'User/EmailSettings';

const methods = ({ request }) => ({

  // /User/GetInfo
  getUserInfo: async () => request('User/GetInfo'),

  // /User/Login
  login: async ({ uname, password }) =>
    request('User/Login', { method: 'POST', body: { uname, password } }),


  // /User/Logout
  logout: async () => request('User/Logout'),


  // /User/EmailSettings
  getEmailSettings: () => request(API_EMAIL_SETTINGS),
  updateEmailSettings: ({ email, receiveEmails: recv_emails }) =>
    request(
      API_EMAIL_SETTINGS,
      { method: 'PUT', body: { email, recv_emails } },
    ),

  // /User/SaveAccountInformation
  putUser: (id, user) => request('User/AccountInformation', {
    method: 'PUT', body: user,
  }),

  // /User/RequestPasswordResetEmail
  submitResetRequest: ({ email }) =>
    request('User/RequestReset',
      { method: 'POST', body: { email } }),

  submitDecryptResetRequest: ({ email }) =>
    request('User/RequestReset',
      { method: 'POST', body: { email, "decrypt":1 } }),


  // /User/ResetPassword
  submitPasswordReset: ({ secret, newpassword }) =>
    request('User/ResetPassword',
      { method: 'POST', body: { secret, newpassword } }),

  // /User/RequestPasswordResetEmail
  submitUsernameRequest: ({ email }) =>
    request('User/RequestUsername',
      { method: 'POST', body: { email } }),

  // Account Information
  getAccountInformation: () => request('User/AccountInformation'),

  // Payment Information
  getPaymentInformation: async () => request('User/PaymentInformation'),
  savePaymentInformation: async body => request('User/PaymentInformation', {
    method: 'PUT',
    body,
  }),
  renewSubscription: async body => request('User/Subscribe/Renew', {
    method: 'PUT',
    body,
  }),
  deleteSubscription: async () => request('User/PaymentInformation', { method: 'DELETE' }),
  deleteUser: async () => request('User', { method: 'DELETE' }),
});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/user.js